import React from 'react';
import db from '../data/db.json';
import './Gallery.css';

const Gallery = () => {
  const { title, subtitle, projects } = db.gallery;

  return (
    <div className="gallery">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </section>

      <section className="gallery-content">
        <div className="container">
          <div className="gallery-grid">
            {projects.map((project) => (
              <div key={project.id} className="gallery-item">
                <div className="gallery-image">
                  <div className="image-placeholder">{project.image}</div>
                </div>
                <div className="gallery-info">
                  <h3 className="gallery-title">{project.title}</h3>
                  <p className="gallery-category">{project.category}</p>
                  <p className="gallery-description">{project.description}</p>
                  <span className="gallery-year">{project.year}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;

